import { ComponentWithChildren } from 'modules/common/types';
import { createContext, useContext } from 'react';

import { ContextType } from './type';
import { useProviderValue } from './value';

const AttachDonorsModalContext = createContext<ContextType | null>(null);

const AttachDonorsModalProvider: ComponentWithChildren = ({ children }) => {
  const providerValue = useProviderValue();

  return (
    <AttachDonorsModalContext.Provider value={providerValue}>
      {children}
    </AttachDonorsModalContext.Provider>
  );
};

export const useAttachDonorsModalContext = () => {
  const context = useContext(AttachDonorsModalContext);
  if (context === undefined) {
    throw new Error(
      'the useAttachDonorsModalContext should be used within AttachDonorsModalProvider!'
    );
  }

  return context;
};

export default AttachDonorsModalProvider;
